import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "cms-site-grid",
  name: "站点选择网格",
  icon: "站",
  group: "CMS通用",
  description: "展示站点选择网格，供用户快速进入不同站点。",
  defaultProps: {
    "columns": 3,
    "showLogo": true
}
}
